import cx from 'classnames';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown } from '@untitledui/icons';
import { LinkProps } from 'config/links';

import s from './sidelink.module.scss';

const isPathActive = (pathname: string, path: string) => pathname.includes(path);

export const SideLink = ({ link }: { link: LinkProps }) => {
  const { label, path, icon, subLinks = [] } = link;
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const hasSubLinks = subLinks.length > 0;
  const isActive =
    isPathActive(pathname, path) || subLinks.some((sub) => isPathActive(pathname, sub.path));
  const [isOpen, setIsOpen] = useState(isActive);

  // Раздел раскрывается сам, когда пользователь попал в него по ссылке
  useEffect(() => {
    if (isActive) setIsOpen(true);
  }, [isActive]);

  const content = (
    <>
      {icon && <span className={s.icon}>{icon}</span>}
      <span className={s.label}>{t(label)}</span>
      {hasSubLinks && <ChevronDown className={cx(s.chevron, { [s.chevronOpen]: isOpen })} />}
    </>
  );

  return (
    <li>
      {hasSubLinks ? (
        <button
          type="button"
          className={cx(s.item, { [s.active]: isActive })}
          aria-expanded={isOpen}
          onClick={() => setIsOpen((open) => !open)}
        >
          {content}
        </button>
      ) : (
        <Link to={path} className={cx(s.item, { [s.active]: isActive })}>
          {content}
        </Link>
      )}

      {hasSubLinks && isOpen && (
        <ul className={s.subMenu}>
          {subLinks.map((sub) => (
            <li key={sub.label}>
              <Link
                to={sub.path}
                className={cx(s.subLink, { [s.subLinkActive]: sub.path === pathname })}
              >
                {t(sub.label)}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};
